<template>
  <div>
    <div class="all-users-page">
      <h1 class="page-header color-1-100">Dashboard promotions</h1>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">
            {{ promotions.length + (promotions.length === 1 ? ' promotion' : ' promotions') }}
          </div>
        </div>
        <a href="#"
           v-on:click.prevent="displayAddForm()"
           class="data-list-add"
           :class="[{ 'data-list-add__close': addFormDisplay}]"
           tabindex="-1">Add new promotion</a>
      </div>
      <div class="categories-add-form" v-if="addFormDisplay">
        <div class="form-group">
          <div class="form-element">
            <label for="input-promotion-title" class="form-label color-2-63">Title</label>
            <input type="text"
                   id="input-promotion-title"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newPromotion.title"/>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="form-element">
            <label for="textarea-promotion-desc" class="form-label color-2-63">Text</label>
            <vue-editor
              name="text"
              id="textarea-promotion-desc"
              :editorToolbar="editorToolbar"
              class="form-control form-control__editor"
              v-model="newPromotion.text" />
          </div>
          <div class="form-element">
            <label for="promotion-button" class="form-label color-2-63">Button text</label>
            <input
                    name="promotion-button"
                    id="promotion-button"
                    v-model="newPromotion.button"
                    class="form-control form-control__input background-1-10-disabled  border-1-10-disabled" />
          </div>
          <div class="form-element">
            <label for="promotion-link" class="form-label color-2-63">Link</label>
            <input
                    name="promotion-desc"
                    id="promotion-link"
                    v-model="newPromotion.link"
                    class="form-control form-control__input background-1-10-disabled  border-1-10-disabled" />
          </div>
          <div class="form-element">
            <label for="button-roles" class="form-label color-2-63">Access</label>
            <v-select class="form-control form-control__select"
                      :searchable = false
                      :multiple="true"
                      v-model="newPromotion.roles"
                      :options="getRolesForSelect"
                      data-lpignore="true"
                      name="roles"
                      id="button-roles" />
          </div>
          <div class="form-element">
            <label for="button-companies" class="form-label color-2-63">Company specific</label>
            <v-select class="form-control form-control__select"
                      :searchable = true
                      :multiple="true"
                      v-model="newPromotion.companies"
                      :options="getCompaniesForSelect"
                      data-lpignore="true"
                      name="companies"
                      id="button-companies" />
          </div>
          <div class="form-element">
            <label for="button-industries" class="form-label color-2-63">Industry specific</label>
            <v-select class="form-control form-control__select"
                      :searchable = true
                      :multiple="true"
                      v-model="newPromotion.industries"
                      :options="getIndustriesForSelect"
                      data-lpignore="true"
                      name="industries"
                      id="button-industries" />
          </div>
          <div class="form-element target-group">
            <div class="form-group form-group-half">
              <div class="form-element">
                <label for="button-targetUsers" class="form-label color-2-63">Target users</label>
                <v-select class="form-control form-control__select"
                          :searchable="false"
                          :multiple="false"
                          v-model="newPromotion.targetUsers"
                          :options="targetUsers"
                          data-lpignore="true"
                          name="targetUsers"
                          id="button-targetUsers" />
              </div>
            </div>

            <div class="form-group form-group-half" id="date-selector">
              <template v-if="newPromotion.targetUsers !== null">
                <div class="form-element">
                  <label for="new-company-subscription-end" class="form-label color-2-63">Date</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         data-lpignore="true"
                         id="new-company-subscription-end"
                         name="Subscription ends"
                         @focus="datepicker.shown = true"
                         v-model="newPromotion.targetDate"
                  />
                  <div class="datepicker" v-show="datepicker.shown">
                    <div class="datepicker-calendar-half">
                      <datepicker
                        :inline="true"
                        v-model="datepicker.targetDate"
                        @selected="dateSelected($event)"
                        :open-date="datepicker.targetDate"
                        :format="'dd/MM/yyyy'"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="form-element">
            <input type="checkbox" class="form-control form-control__checkbox"
                   data-lpignore="true"
                   :id="'new-active-' + newPromotion.id"
                   name="active"
                   v-model="newPromotion.active"/>
            <label :for="'new-active-' + newPromotion.id" class="form-label color-2-63">Enabled</label>
          </div>
        </div>
        <div class="form-group">
          <div class="form-element featured-image">
            <span class="form-label color-2-63">Image</span>
            <label class="form-label color-2-63 form-label--file-upload" v-show="!isFileUploaded">
              <div class="upload-text">+Upload image</div>
              <input type="file"
                      :id="'promotionImage-0'"
                      name="Thumbnail"
                      data-vv-as='"Thumbnail"'
                      value.sync="formInfo.thumbnail"
                      v-validate.reject="veeValidateFileUploadRules"
                      @change="onThumbnailFileChange($event, 0)"
                      class="form-control form-control--file" />
            </label>
            <div class="thumbnailFilePreview" v-if="isFileUploaded" v-bind:style="{ backgroundImage: getImage(newPromotion.image) }" ></div>
            <button
                    type="button"
                    v-if="isFileUploaded"
                    @click="removeThumbnail(0)"
                    class="btn btn--remove-element">
              <span class="btn__text">-Remove image</span>
            </button>
          </div>
          <div class="form-element">
            <label for="promotion-image-alt" class="form-label color-2-63">Image alt</label>
            <input
              name="promotion-image-alt"
              id="promotion-image-alt"
              v-model="newPromotion.imageAlt"
              class="form-control form-control__input background-1-10-disabled  border-1-10-disabled" />
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="update-data update-data__details">
          <a href="#" v-on:click.prevent="closeAddForm()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Cancel</a>
          <a href="#" v-on:click.prevent="createPromotion()" class="save-edit background-1-100 color-2-100 save-edit-details">Create promotion</a>
        </div>
        <hr class="add-form-delimiter" />
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead class="categories-list-body__head">
          <tr>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">ID</th>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">Image</th>
            <th class="categories-list-search-col text-left categories-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchString"
                          type="search"
                          class="table-search"
                          placeholder="Title ..."/>
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">Enabled</th>
            <th colspan="2" class="cellpadding categories-list-body__head_actions table-head-ceil">Actions</th>
          </tr>
          </thead>
          <tbody class="categories-list-body__body">
          <tr v-for="(promotion, i) in updatedPromotions">
            <td class="text-center cellpadding" v-if="promotion.type === 'show'" style="width: 50px;">
              {{promotion.id}}
            </td>
            <td class="cellpadding" v-if="promotion.type === 'show'" style="width: 50px;">
              <div class="thumbnailFilePreview" v-if="promotion.image" v-bind:style="{ backgroundImage: getImage(promotion.image) }" style="width: 50px; height: 50px; border: none;"></div>
            </td>
            <td class="cellpadding" v-if="promotion.type === 'show'">
              {{ promotion.title }}
            </td>
            <td class="cellpadding text-center" v-if="promotion.type === 'show'">
              {{ promotion.active ? 'Yes' : 'No' }}
            </td>
            <td class="cellpadding text-center" v-if="promotion.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m edit-btn"
                      @click="switchEditMode(promotion.id)">
                <span class="table-tooltip">Edit</span>
              </button>
            </td>
            <td class="cellpadding text-center" v-if="promotion.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m delete-btn"
                      @click="removePromotion(promotion.id)">
                <span class="table-tooltip">Delete</span>
              </button>
            </td>
            <td colspan="6" v-if="promotion.type === 'edit'" class="edit-row chapter-edit">
              <div class="wrap-edit-form">
                <div class="row-edit-form">
                  <div>
                    <div class="form-group image-alt">
                      <div class="form-element featured-image">
                        <label class="form-label color-2-63 form-label--file-upload" v-show="!promotion.image">
                          <div class="upload-text">+Upload image</div>
                          <input
                            type="file"
                            :id="'promotionImage-' + promotion.id"
                            name="Thumbnail"
                            data-vv-as='"Thumbnail"'
                            value.sync="formInfo.thumbnail"
                            v-validate.reject="veeValidateFileUploadRules"
                            @change="onThumbnailFileChange($event, promotion.id)"
                            class="form-control form-control--file" />
                        </label>
                        <div class="thumbnailFilePreview" v-if="promotion.image" v-bind:style="{ backgroundImage: getImage(promotion.image) }" ></div>
                        <button
                          type="button"
                          v-if="promotion.image"
                          @click="removeThumbnail(promotion.id)"
                          class="btn btn--remove-element">
                          <span class="btn__text">-Remove image</span>
                        </button>
                      </div>
                      <div class="form-element featured-image-alt">
                        <label for="edit-image-alt" class="form-label color-2-63">Image alt</label>
                        <input type="text"
                               id="edit-image-alt"
                               placeholder="Type in promotion image alt"
                               class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                               v-model="promotion.imageAlt">
                      </div>
                    </div>
                  </div>
                  <div>
                    <label for="edit-title" class="form-label color-2-63">Promotion title</label>
                    <input type="text"
                           id="edit-title"
                           placeholder="Type in promotion title"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="promotion.title">
                  </div>
                  <div class="wrap-desc-textarea">
                    <label for="edit-text" class="form-label color-2-63">Promotion text</label>
                    <vue-editor
                      name="text"
                      id="edit-text"
                      :editorToolbar="editorToolbar"
                      class="form-control form-control__editor"
                      v-model="promotion.text" />
                  </div>
                  <div>
                    <label for="edit-button-text" class="form-label color-2-63">Button text</label>
                    <input type="text"
                           id="edit-button-text"
                           placeholder="Type in promotion button text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="promotion.button">
                  </div>
                  <div>
                    <label for="edit-button-link" class="form-label color-2-63">Button link</label>
                    <input type="text"
                           id="edit-button-link"
                           placeholder="Type in promotion link"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="promotion.link">
                  </div>
                  <div>
                    <label for="edit-button-roles" class="form-label color-2-63">Access</label>
                    <v-select class="form-control form-control__select"
                              :searchable = false
                              :multiple="true"
                              v-model="promotion.roles"
                              :options="getRolesForSelect"
                              data-lpignore="true"
                              name="roles"
                              id="edit-button-roles" />
                  </div>
                  <div>
                    <label for="edit-button-companies" class="form-label color-2-63">Company specific</label>
                    <v-select class="form-control form-control__select"
                              :searchable = true
                              :multiple="true"
                              v-model="promotion.companies"
                              :options="getCompaniesForSelect"
                              data-lpignore="true"
                              name="companies"
                              id="edit-button-companies" />
                  </div>
                  <div>
                    <label for="edit-button-industries" class="form-label color-2-63">Industry specific</label>
                    <v-select class="form-control form-control__select"
                              :searchable = true
                              :multiple="true"
                              v-model="promotion.industries"
                              :options="getIndustriesForSelect"
                              data-lpignore="true"
                              name="industries"
                              id="edit-button-industries" />
                  </div>
                  <div class="target-group--edit">
                    <div class="form-element target-group">
                      <div class="form-group form-group-half">
                        <div class="form-element">
                          <label for="button-targetUsers" class="form-label color-2-63">Target users</label>
                          <v-select class="form-control form-control__select"
                                    :searchable="false"
                                    :multiple="false"
                                    v-model="promotion.targetUsers"
                                    :options="targetUsers"
                                    data-lpignore="true"
                                    name="targetUsers"
                                    id="button-targetUsers" />
                        </div>
                      </div>

                      <div class="form-group form-group-half" id="date-selector">
                        <template v-if="promotion.targetUsers !== null">
                          <div class="form-element">
                            <label for="new-company-subscription-end" class="form-label color-2-63">Date</label>
                            <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                                   data-lpignore="true"
                                   id="new-company-subscription-end"
                                   name="Subscription ends"
                                   @focus="editDatepicker.shown = true"
                                   v-model="promotion.targetDate"
                            />
                            <div class="datepicker" v-show="editDatepicker.shown">
                              <div class="datepicker-calendar-half">
                                <datepicker
                                  :inline="true"
                                  v-model="editDatepicker.targetDate"
                                  @selected="dateSelectedEdit($event, promotion)"
                                  :open-date="editDatepicker.targetDate"
                                  :format="'dd/MM/yyyy'"
                                />
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div>
                    <input type="checkbox" class="form-control form-control__checkbox"
                           data-lpignore="true"
                           :id="'edit-active-' + promotion.id"
                           name="active"
                           v-model="promotion.active"/>
                    <label :for="'edit-active-' + promotion.id" class="form-label color-2-63">Enabled</label>
                  </div>
                </div>
                <div class="wrap-table-control-panel">
                  <button type="button" @click="discardChanges(promotion.id)">Cancel</button>
                  <button type="button" @click="editPromotion(promotion.id)">Save</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'dashboard-promotions',
  data () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      promotions: [],
      updatedPromotions: [],
      newPromotion: {
        title: '',
        text: '',
        image: null,
        imageAlt: null,
        active: true,
        link: null,
        button: null,
        roles: null,
        companies: null,
        industries: null,
        targetUsers: null,
        targetDate: null
      },
      datepicker: {
        targetDate: null,
        startDate: null,
        shown: false,
        startShown: false,
        keepFocus: false
      },
      editDatepicker: {
        targetDate: null,
        startDate: null,
        shown: false,
        startShown: false,
        keepFocus: false
      },
      disableAPI: false,
      searchString: '',
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false,
      isFileUploaded: false,
      isEditFileUploaded: false,
      editorToolbar: [
        [{'header': [1, 2, 3, false]}],
        ['bold', 'italic', 'underline', 'strike', {'color': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        ['blockquote', 'code-block', 'link'],
        [{'font': []}],
        [{'align': []}],
        ['clean']
      ]
    }
  },
  methods: {
    ...mapActions([
      'setInformationMsg',
      'clearConfAction',
      'initConfAction',
      'getRoles',
      'getCompanies',
      'getIndustries'
    ]),
    displayAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    closeAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    removePromotion (id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removePromotionById'
      })
    },
    removePromotionConfirmed (id) {
      let self = this
      let thisPromotion = this.updatedPromotions.find((promotion) => promotion.id === id)
      this.$http.delete(api.URLS.promotions + '/' + id, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = thisPromotion.title + ' promotion was successfully deleted.'
            self.infMsgDescription = 'Please note all actions are being logged.'
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            for (let i = 0; i < self.promotions.length; i++) {
              if (self.promotions[i].id === id) {
                self.promotions.splice(i, 1)
                break
              }
            }
          })
          .catch((err) => console.log(err))
    },
    fetchAllContentByScroll () {
      this.$http.get(api.URLS.promotions, api.headersAuthSettings)
        .then((res) => {
          if (res.body) {
            this.promotions = res.body
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    createPromotion () {
      if (this.disableAPI) return
      if (!this.newPromotion.title) return
      let formData = {
        title: this.newPromotion.title,
        text: this.newPromotion.text,
        image: this.newPromotion.image,
        imageAlt: this.newPromotion.imageAlt,
        link: this.newPromotion.link,
        button: this.newPromotion.button,
        roles: this.newPromotion.roles,
        companies: this.newPromotion.companies,
        industries: this.newPromotion.industries,
        active: this.newPromotion.active,
        targetUsers: this.newPromotion.targetUsers ? this.newPromotion.targetUsers.value : null,
        targetDate: this.newPromotion.targetDate
      }
      this.disableAPI = true
      this.$http.post(api.URLS.promotions, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = this.newPromotion.title + ' promotion was successfully added.'
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.newPromotion.title = ''
          this.newPromotion.text = ''
          this.newPromotion.image = null
          this.newPromotion.imageAlt = null
          this.newPromotion.link = ''
          this.newPromotion.button = ''
          this.newPromotion.roles = null
          this.newPromotion.companies = null
          this.newPromotion.industries = null
          this.newPromotion.active = true
          this.newPromotion.targetUsers = null
          this.newPromotion.targetDate = ''
          this.addFormDisplay = false
          this.isFileUploaded = false
          this.fetchAllContentByScroll()
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    switchEditMode (id) {
      for (let promotion of this.updatedPromotions) {
        if (promotion.type === 'edit') promotion.type = null
        if (promotion.id === id && promotion.type === null) {
          promotion.type = 'edit'
          const date = promotion.targetDate ? promotion.targetDate.split('/') : null
          if (date) {
            const formattedDate = new Date(parseInt(date[2]), parseInt(date[1]) - 1, parseInt(date[0]))
            this.editDatepicker.targetDate = promotion.targetDate ? formattedDate : new Date()
          }
        }
      }
    },
    editPromotion (id) {
      if (this.disableAPI) return
      let promotion = this.updatedPromotions.find((promotion) => promotion.id === id && promotion.type === 'edit')
      let formData = {
        id: id,
        title: promotion.title,
        text: promotion.text,
        image: promotion.image,
        imageAlt: promotion.imageAlt,
        link: promotion.link,
        button: promotion.button,
        roles: promotion.roles,
        companies: promotion.companies,
        industries: promotion.industries,
        active: promotion.active,
        targetUsers: promotion.targetUsers ? promotion.targetUsers.value : null,
        targetDate: promotion.targetDate
      }
      this.disableAPI = true
      this.$http.post(api.URLS.promotions, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.discardChanges(id)
          this.fetchAllContentByScroll()
          this.infMsgTitle = promotion.title + ' promotion was successfully updated.'
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    discardChanges (id) {
      for (let promotion of this.updatedPromotions) {
        if (promotion.id === id && promotion.type === 'edit') {
          promotion.type = null
        }
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    onThumbnailFileChange (e, id) {
      let self = this
      let input = document.getElementById('promotionImage-' + id)
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        let reader = new FileReader()
        if (id === 0) {
          reader.onload = function (e) {
            self.isFileUploaded = true
            self.newPromotion.image = e.target.result
          }
        } else {
          let promotion = this.updatedPromotions.find((promotion) => promotion.id === id && promotion.type === 'edit')
          reader.onload = function (e) {
            self.isEditFileUploaded = true
            promotion.image = e.target.result
          }
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    removeThumbnail (id) {
      var input = document.getElementById('promotionImage-' + id)
      input.value = null
      if (id === 0) {
        this.isFileUploaded = false
        this.newPromotion.image = null
      } else {
        let promotion = this.updatedPromotions.find((promotion) => promotion.id === id && promotion.type === 'edit')
        this.isEditFileUploaded = false
        promotion.image = null
      }
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      if (!payload && payload !== '') {
        return true
      }
      return payload.indexOf('data:') !== -1
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    getImageFullPath (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload
    },
    dateSelected (e) {
      this.newPromotion.targetDate = this.convertDate(e, '/')
      this.datepicker.shown = false
    },
    dateSelectedEdit (e, promotion) {
      promotion.targetDate = this.convertDate(e, '/')
      this.editDatepicker.shown = false
    },
    convertDate (payload, delimiter) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()

      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }

      return toDoubleDigit(day) + delimiter + toDoubleDigit(month) + delimiter + fullYear
    },
    isDescendant (parent, child) {
      let node = child.parentNode
      while (node !== null) {
        if (node === parent) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    documentClick (e) {
      let self = this
      if (self.datepicker.shown) {
        let datepicker = document.getElementById('date-selector')
        let target = e.target
        if (!this.isDescendant(datepicker, target)) {
          self.datepicker.shown = false
          self.editDatepicker.shown = false
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getConfData',
      'getRolesForSelect',
      'getCompaniesForSelect',
      'getIndustriesForSelect'
    ]),
    veeValidateFileUploadRules () {
      return {
        required: false,
        mimes: 'image/*'
      }
    },
    filteredPromotions () {
      return this.promotions.filter((promotion) => promotion.title.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
    },
    targetUsers () {
      return [
        {
          label: 'Created before',
          value: 1
        },
        {
          label: 'Created after',
          value: 2
        }
      ]
    }
  },
  watch: {
    filteredPromotions: function () {
      let updatedPromotions = []
      this.filteredPromotions.forEach((promotion, i, arr) => {
        promotion.type = 'show'
        updatedPromotions.push(promotion)
        const editPromotion = {
          type: null,
          id: promotion.id,
          title: promotion.title,
          text: promotion.text,
          image: promotion.image,
          imageAlt: promotion.image_alt,
          active: promotion.active,
          button: promotion.button,
          link: promotion.link,
          targetDate: this.convertDate(promotion.target_date, '/')
        }
        if (promotion.roles && promotion.roles.length) {
          editPromotion.roles = []
          promotion.roles.forEach((row) => {
            editPromotion.roles.push({
              id: row.id,
              label: row.name,
              value: row.id
            })
          })
        }
        if (promotion.companies && promotion.companies.length) {
          editPromotion.companies = []
          promotion.companies.forEach((row) => {
            editPromotion.companies.push({
              id: row.id,
              label: row.name,
              value: row.id
            })
          })
        }
        if (promotion.industries && promotion.industries.length) {
          editPromotion.industries = []
          promotion.industries.forEach((row) => {
            editPromotion.industries.push({
              id: row.id,
              label: row.name,
              value: row.id
            })
          })
        }
        if (promotion.target_users) {
          editPromotion.targetUsers = this.targetUsers.find(t => t.value === promotion.target_users)
        }
        updatedPromotions.push(editPromotion)
      })
      this.updatedPromotions = updatedPromotions
    },
    'getConfData.actionConfirmed' (value) {
      let actionName = this.getConfData.actionName
      if (value) {
        switch (actionName) {
          case 'removePromotionById':
            this.removePromotionConfirmed(this.getConfData.actionId)
            this.clearConfAction()
            break
        }
      }
    },
    addFormDisplay (value) {
      if (value) {
        this.newPromotion.targetDate = this.convertDate(new Date(), '/')
        this.datepicker.targetDate = new Date()
      }
    }
  },
  components: {},
  mounted () {
    this.fetchAllContentByScroll()
    this.getRoles()
    this.getCompanies()
    this.getIndustries()
    document.addEventListener('click', this.hideSubMenuTableHead)
    document.addEventListener('click', this.documentClick)
  },
  created () {
    document.title = 'Dashboard promotions | Clear Assured'
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname])
      window._paq.push(['setDocumentTitle', document.title])
      window._paq.push(['trackPageView'])
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed () {
    document.removeEventListener('click', this.hideSubMenuTableHead)
    document.removeEventListener('click', this.documentClick)
  }
}
</script>


<style lang="scss">
  #date-selector {
    position: relative;
  }
  .datepicker {
    width: auto !important;
    height: auto !important;
    left: 0 !important;
    padding: 0 !important;
  }
  .target-group {
    margin: 0 !important;
    &--edit {
      margin-left: -5px !important;
      margin-right: -5px !important;
      max-width: unset !important;
    }
  }
</style>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// DashboardPromotions.vue?884a1f94